<template>
  <div class="select-range d-inline-flex w-100">
    <b-form-select
      v-model="from"
      size="sm"
      :options="fromOptions"
      :class="selectFromCls"
    />
    <div class="mx-0 mx-md-1 mx-lg-2">
      &nbsp;-&nbsp;
    </div>
    <b-form-select
      v-model="to"
      size="sm"
      :options="toOptions"
      :class="selectToCls"
    />
  </div>
</template>

<script>
export default {
  name: 'SelectRange',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    variant: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      from: this.value?.from ?? null,
      to: this.value?.to ?? null
    }
  },
  computed: {
    baseOptions () {
      return [{ value: null, text: '—' }, ...this.options]
    },
    fromOptions () {
      return this.to !== null
        ? this.baseOptions.filter(o => o.value === null || o.value <= this.to)
        : this.baseOptions
    },
    toOptions () {
      return this.from !== null
        ? this.baseOptions.filter(o => o.value === null || o.value >= this.from)
        : this.baseOptions
    },
    selectFromCls () {
      return this.variant && this.from !== null
        ? `border-${this.variant} text-${this.variant}`
        : ''
    },
    selectToCls () {
      return this.variant && this.to !== null
        ? `border-${this.variant} text-${this.variant}`
        : ''
    }
  },
  watch: {
    value: {
      handler (n) {
        this.from = n?.from ?? null
        this.to = n?.to ?? null
      },
      deep: true
    },
    from () {
      this.$emit('input', this.getValue())
    },
    to () {
      this.$emit('input', this.getValue())
    }
  },
  methods: {
    getValue () {
      const value = {}
      if (this.from !== null) {
        value.from = this.from
      }
      if (this.to !== null) {
        value.to = this.to
      }
      return value
    }
  }
}
</script>
